export enum Modules {
  agrishop = "agrishop",
  credits = "credits",
  better_extension = "better_extension",
  farm_manager = "farm_manager",
  produce_market = "produce_market",
  garden_mapping = "garden_mapping",
}

export interface Info {
  name: string;
  phoneNumber: string;
  userId: string;
  location: string;
  crop: string;

  module: string;
  enterprise?: string;
  sessionTime: number;
}

export interface ModuleUsage {
  [Modules.agrishop]: Agrishop;
}

export interface SessionDataInfo<T> {
  info: Info;
  sessions: { [id: string]: SessionInstance<T>[] };
}

export interface FormattedSessionDataInfo<T> {
  info: Info;
  sessions: SessionInstance<T>[][];
}

export interface Agrishop {
  [date: string]: DailyUsersData;
}

export interface DailyUsersData {
  [userId: string]: SessionDataInfo<AgrishopTags>;
}

export interface FormattedDailyUsersData {
  [userId: string]: FormattedSessionDataInfo<AgrishopTags>;
}
export interface SessionInstance<T> {
  tag: T;
  timestamp: number;
  productId?: string;
}

export enum AgrishopTags {
  OpenAgriShop = "Open AgriShop",
  IncreaseItemQuantities = "Increase item quantities",
  AddItemsToBag = "Add items to bag",
  ChangeUnits = "Change Units",
}

export class ASessionInstance implements SessionInstance<AgrishopTags> {
  tag: AgrishopTags;
  timestamp: number = 0;
  productId?: string;
}
